import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './clacmycloud.states';
import { ec2Reducer } from './ec2.reducer';

export const reducers: ActionReducerMap<AppState> = {
  ec2sState: ec2Reducer
}; 